import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import rutas from '@/router'

import Login from '@/views/login/login.vue'
import Home from '@/views/Home.vue'

// Rutas y Usuarios
import Usuarios            from '@/views/rutas_usuarios/Usuarios.vue'
import MiPerfil            from '@/views/rutas_usuarios/MiPerfil.vue'
import PermisosUsuario     from '@/views/rutas_usuarios/PermisosUsuario.vue'


// Cotizador
import Articulos     from '@/views/cotizador/CatProductos.vue'
import PaquetesArt      from '@/views/cotizador/PaquetesArt.vue'


// REQUISIONES
import Departamentos               from '@/views/requisiciones/Departamentos.vue'
import Puestos                     from '@/views/requisiciones/Puestos.vue'
import Jerarquias                  from '@/views/requisiciones/Jerarquias.vue'

import Sucursales                  from '@/views/catalogos/Sucursales.vue'
import Alumnos                     from '@/views/catalogos/Alumnos.vue'

import Cursos                     from '@/views/grupos/Cursos.vue'
import Grupos                     from '@/views/grupos/Grupos.vue'
import MisGrupos                  from '@/views/grupos/MisGrupos.vue'
import GruposSucursal             from '@/views/grupos/GruposSucursal.vue'
import Horarios                   from '@/views/grupos/Horarios.vue'

import Inscripciones              from '@/views/finanzas/Inscripciones.vue'
import InscripcionesSucursal      from '@/views/finanzas/InscripcionesSucursal.vue'
import MisPagos                   from '@/views/finanzas/MisPagos.vue'
import Colegiaturas               from '@/views/finanzas/Colegiaturas.vue'
import MiColegiatura              from '@/views/finanzas/MiColegiatura.vue'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: '',
  base: process.env.BASE_URL,
  routes: [

    //MODULO DE LOGIN
    { path: '/', name: 'login' , component: Login, 
      meta: { libre: true, ADMIN: true, USUARIO: true, SUPERVISOR: true} },
    { path: '/home', name: 'home' , component: Home, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true } },

    { path: '/usuarios', name: 'Usuarios' , component: Usuarios, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true} },

    { path: '/MiPerfil', name: 'MiPerfil' , component: MiPerfil, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true} },

    // COTIZADOR
    { path: '/articulos', name: 'Articulos'   , component: Articulos, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true} },

    { path: '/paquetes', name: 'Paquetes'   , component: PaquetesArt, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true} },

    // REQUISICIONES

    { path: '/departamentos'                  , name: 'Departamentos'              , component: Departamentos, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/puestos'                        , name: 'Puestos'                    , component: Puestos, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/jerarquias'                     , name: 'Jerarquias'                 , component: Jerarquias, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/permisosusuario'             , name: 'PermisosUsuario'               , component: PermisosUsuario, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/sucursales'                  , name: 'Sucursales'                    , component: Sucursales, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/alumnos'                     , name: 'Alumnos'                       , component: Alumnos, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    // Acciones de los grupos
    { path: '/misgrupos'                     , name: 'MisGrupos'                 , component: MisGrupos, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/grupos'                     , name: 'Grupos'                       , component: Grupos, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/horarios'                   , name: 'Horarios'                     , component: Horarios, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},
      
    { path: '/cursos'                     , name: 'Cursos'                       , component: Cursos, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/grupossucursal'             , name: 'GruposSucursal'               , component: GruposSucursal, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/inscripciones'             , name: 'Inscripciones'                 , component: Inscripciones, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/inscripcionessucursal'             , name: 'InscripcionesSucursal'                 , component: InscripcionesSucursal, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/mispagos'             , name: 'MisPagos'                 , component: MisPagos, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/colegiaturas'             , name: 'Colegiaturas'                 , component: Colegiaturas, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},

    { path: '/micolegiatura'             , name: 'MisColegiaturas'                 , component: MiColegiatura, 
      meta: { ADMIN: true, USUARIO: true, SUPERVISOR: true }},


  ]
})

router.beforeEach( (to, from, next) => {
  if(to.matched.some(record => record.meta.libre)){
    next()
  }else if(store.state.login.datosUsuario.admin === 'ADMIN'){
    if(to.matched.some(record => record.meta.ADMIN)){
      next()
    }
  }else if(store.state.login.datosUsuario.admin === 'USUARIO'){
    if(to.matched.some(record => record.meta.USUARIO)){
      next()
    }
  }else if(store.state.login.datosUsuario.admin === 'SUPERVISOR'){
    if(to.matched.some(record => record.meta.SUPERVISOR)){
      next()
    }
  }else{
    next({
      name: 'login'
    })
  }
})

export default router

